(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nope-bundle-preview"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.nope-bundle-preview').forEach((root) => {
    if (root.dataset.nopeBundlePreviewInitialized === 'true') return;
    root.dataset.nopeBundlePreviewInitialized = 'true';

    const variantData = root.querySelector('[data-nope-bundle-preview-variants]');
    const variantInput = root.querySelector('[data-nope-bundle-variant-input]');
    const submitButton = root.querySelector('[data-nope-bundle-submit]');
    const errorMessage = root.querySelector('[data-nope-bundle-error]');
    const selectedShadeLabel = root.querySelector('[data-nope-bundle-selected-shade]');
    const form = root.querySelector('form');
    const sellingPlanSelect = root.querySelector('[data-nope-bundle-selling-plan]');
    const deliveryPicker = root.querySelector('[data-nope-bundle-delivery-picker]');
    const deliveryToggle = root.querySelector('[data-nope-bundle-delivery-toggle]');
    const deliveryMenu = root.querySelector('[data-nope-bundle-delivery-menu]');
    const deliveryLabel = root.querySelector('[data-nope-bundle-delivery-label]');
    const bogoPack = root.dataset.nopeBundleBogoPack;
    const giftVariantId = root.dataset.nopeBundleGiftVariant;
    const giftPack = root.dataset.nopeBundleGiftPack;

    if (!variantData || !variantInput || !submitButton) return;

    const variants = JSON.parse(variantData.textContent);
    let selectedPack = root.querySelector('[data-nope-bundle-pack].is-selected')?.dataset.nopeBundlePack || variants[0]?.options[1];
    let selectedShade = root.querySelector('[data-nope-bundle-shade].is-selected')?.dataset.nopeBundleShade || variants[0]?.options[0];

    const updateSelection = () => {
      const selectedVariant = variants.find((variant) => variant.options[0] === selectedShade && variant.options[1] === selectedPack);

      root.querySelectorAll('[data-nope-bundle-pack]').forEach((pack) => {
        const packValue = pack.dataset.nopeBundlePack;
        const availableForShade = variants.some((variant) => variant.options[0] === selectedShade && variant.options[1] === packValue && variant.available);
        pack.disabled = !availableForShade;
        pack.classList.toggle('is-selected', packValue === selectedPack);
        pack.setAttribute('aria-checked', String(packValue === selectedPack));
      });

      root.querySelectorAll('[data-nope-bundle-shade]').forEach((shade) => {
        const shadeValue = shade.dataset.nopeBundleShade;
        const availableForPack = variants.some((variant) => variant.options[0] === shadeValue && variant.options[1] === selectedPack && variant.available);
        shade.disabled = !availableForPack;
        shade.classList.toggle('is-selected', shadeValue === selectedShade);
        shade.setAttribute('aria-checked', String(shadeValue === selectedShade));
      });

      if (selectedVariant && selectedVariant.available) {
        variantInput.value = selectedVariant.id;
        submitButton.disabled = false;
        errorMessage.hidden = true;
      } else {
        variantInput.value = '';
        submitButton.disabled = true;
        errorMessage.textContent = errorMessage.dataset.unavailableMessage;
        errorMessage.hidden = false;
      }

      if (selectedShadeLabel) selectedShadeLabel.textContent = selectedShade;
    };

    const removeInjectedAppstleControls = () => {
      root.querySelectorAll('[id^="appstle_subscription_widget"] [name="selling_plan"]').forEach((control) => {
        control.removeAttribute('name');
      });
    };

    const closeDeliveryMenu = (returnFocus = false) => {
      if (!deliveryMenu || !deliveryToggle) return;
      deliveryMenu.hidden = true;
      deliveryToggle.setAttribute('aria-expanded', 'false');
      if (returnFocus) deliveryToggle.focus();
    };

    const selectDeliveryPlan = (option) => {
      if (!sellingPlanSelect || !deliveryLabel) return;
      sellingPlanSelect.value = option.dataset.sellingPlanValue || '';
      sellingPlanSelect.dispatchEvent(new Event('change', { bubbles: true }));
      deliveryLabel.textContent = option.textContent.trim();
      root.querySelectorAll('[data-nope-bundle-selling-plan-option]').forEach((item) => {
        const isSelected = item === option;
        item.classList.toggle('is-selected', isSelected);
        item.setAttribute('aria-selected', String(isSelected));
      });
      closeDeliveryMenu();
    };

    deliveryToggle?.addEventListener('click', () => {
      const isOpen = deliveryToggle.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        closeDeliveryMenu();
        return;
      }
      deliveryMenu.hidden = false;
      deliveryToggle.setAttribute('aria-expanded', 'true');
    });

    root.querySelectorAll('[data-nope-bundle-selling-plan-option]').forEach((option) => {
      option.addEventListener('click', () => selectDeliveryPlan(option));
      option.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeDeliveryMenu(true);
      });
    });

    document.addEventListener('click', (event) => {
      if (deliveryPicker && !deliveryPicker.contains(event.target)) closeDeliveryMenu();
    });

    deliveryToggle?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeDeliveryMenu();
      if (event.key === 'ArrowDown' && deliveryMenu?.hidden) {
        event.preventDefault();
        deliveryToggle.click();
        deliveryMenu.querySelector('[data-nope-bundle-selling-plan-option]')?.focus();
      }
    });

    root.querySelectorAll('[data-nope-bundle-pack]').forEach((pack) => {
      pack.addEventListener('click', () => {
        selectedPack = pack.dataset.nopeBundlePack;
        const matchingShade = variants.find((variant) => variant.options[0] === selectedShade && variant.options[1] === selectedPack && variant.available);
        if (!matchingShade) selectedShade = variants.find((variant) => variant.options[1] === selectedPack && variant.available)?.options[0] || selectedShade;
        updateSelection();
      });
    });

    root.querySelectorAll('[data-nope-bundle-shade]').forEach((shade) => {
      shade.addEventListener('click', () => {
        selectedShade = shade.dataset.nopeBundleShade;
        updateSelection();
      });
    });

    form?.addEventListener('submit', async (event) => {
      const includesBogo = selectedPack === bogoPack;
      const includesGift = giftVariantId && selectedPack === giftPack;
      if (!includesBogo && !includesGift) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (!form.checkValidity() || !variantInput.value) {
        form.reportValidity();
        return;
      }

      const bundleItem = { id: Number(variantInput.value), quantity: 1 };
      if (sellingPlanSelect?.value) bundleItem.selling_plan = Number(sellingPlanSelect.value);
      const items = [bundleItem];
      if (includesBogo) items.push({ id: Number(variantInput.value), quantity: 1 });
      if (includesGift) items.push({ id: Number(giftVariantId), quantity: 1 });

      submitButton.setAttribute('disabled', 'disabled');
      submitButton.setAttribute('aria-busy', 'true');
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));

      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items, sections: sections.join(','), sections_url: `${Shopify.routes.root}variants/${variantInput.value}` })
      });

      submitButton.removeAttribute('disabled');
      submitButton.removeAttribute('aria-busy');
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));

      const responseJson = await response.json();
      if (!response.ok) {
        errorMessage.textContent = responseJson.description;
        errorMessage.hidden = false;
        form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: responseJson.description } }));
        return;
      }

      if (window.themeVariables.settings.cartType === 'page' || window.themeVariables.settings.pageType === 'cart') {
        window.location.href = `${Shopify.routes.root}cart`;
        return;
      }

      const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      cart.sections = responseJson.sections;
      form.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: responseJson.items, cart } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart } }));
    }, true);

    updateSelection();
    removeInjectedAppstleControls();

    new MutationObserver(removeInjectedAppstleControls).observe(root, { childList: true, subtree: true });
  });
  } catch(e) { console.error(e); }
})();

})();
